import { IAction } from '@app/common/interfaces';

export enum GAME_BUILDS_COUNT {
  RECEIVE_COUNT = 'gameBuildsCount/RECEIVE_COUNT'
}

export function receiveGameBuildsCount(data: number): IAction<number> {
  return { type: GAME_BUILDS_COUNT.RECEIVE_COUNT, data };
}
